import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { Publication } from '@portal-core/publications/models/publication.model';

@CollectionStateSelectors({
  stateType: PublicationsState
})
@State<PublicationsState>({
  name: PublicationsState.source,
})
@Service({ autoProvided: false })
export class PublicationsState extends CollectionStateBase {
  static override source = 'Publications';
  getSource(): string {
    return PublicationsState.source;
  }
}

@Service()
export class PublicationsDataService extends CollectionDataServiceBase<Publication> {
  protected readonly stateType = PublicationsState;
}
